//Imports node_modules
import React, { useContext, useEffect, useState, useCallback } from 'react'
import Modal from 'react-modal';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Imports Css
import './UserPage.css'

//Import Components
import PeCard from '../../../components/layout/peCard/PeCard';
import TopBar from '../../../components/Global/topBar/TopBar';
import BottomBar from '../../../components/Global/bottombar/BottomBar';

//Import Data
import { axiosCalls } from '../../../data/AxiosCalls';
import { globalVariables } from '../../../data/GlobalVariables'
import { globalModals } from '../../../data/GlobalModals'
import PinModal from '../../../components/Global/modals/pinModal/PinModal';

//Pagina onde o cliente selciona a entidade
const UserPage = (props) => {
    //--- Variaveis

    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Variaveis de contexto                                                                    *
    //---------------------------------------------------------------------------------------------------------------------------------------------------
    const {
        setPe,
        setZone,
        ResetPe,
        apiBaseUrl,
        setGroupPe,
        setZoneAndPe,
        DismissPinModal,
        setIsInsertingGlobal,
        setIsEdetingGlobalUpdate,
        setCloseProductionRedirectionVars,
    } = useContext(globalVariables)

    const {
        ShowPinModal,
        ShowMessageModal,
        DismisMessageModal,
        ShowLoadingModal,
        DismisLoadingModal,
    } = useContext(globalModals);

    const {
        AxiosPost
    } = useContext(axiosCalls)

    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Variaveis locais                                                                         *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    const cookies = new Cookies();
    const navigate = useNavigate();

    const [response, setResponse] = useState([])
    const [withGroup, setWithGroup] = useState(true)
    const [isInsertingGroup, setIsInsertingGroup] = useState(false)
    const [isEdetingGroup, setIsEdetingGroup] = useState(false)
    const [reponseSize, setReponseSize] = useState(0)
    const [hasAccess, setHasAccess] = useState(0);
    const [checkStatus, setCheckStatus] = useState(false);
    const [currentPe, setCurrentPe] = useState('Vazio');
    const [isPageloaded, setisPageloaded] = useState(new Date());


    const notify = () => toast.success('Operação concluida!', {
        position: "top-right",
        autoClose: 2200,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const queryParams = new URLSearchParams(window.location.search);


    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Variaveis UseCallback                                                                    *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    const currentGroup = useCallback(function (receivedPe) {
        //Verifica se tem password e pede a mesma ao utiliziador

        if (receivedPe.pin.trim() !== '0' && receivedPe.pin.trim() !== '' && !isInsertingGroup && !isEdetingGroup) {
            setCurrentPe(receivedPe);
            ShowPinModal();
        } else {

            computSelectedPe(receivedPe);
        }

        // eslint-disable-next-line
    }, [setWithGroup, isInsertingGroup, isEdetingGroup, reponseSize, ShowMessageModal])

    const deleteGroup = useCallback(function () {
        resetVarsGroup()
        // eslint-disable-next-line
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Funçoes UseEffect                                                                        *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {
        setPe('empty')

        if (queryParams.get('success')) {
            notify();
        }



        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        //Query para actualiza o nome da tablet
        AxiosPost(
            ('UniqueIdDisp/verifyUniqueIdDisp?uniqueId=' + cookies.get('uniqueDeviceID')), 'function',
            function emptyresponse(reposnseempty) {
                console.log('Não foi possivel encontrar o nome')
            }
            ,
            function comutereponse(response) {
                localStorage.setItem('dispName', response.data[0].nome.trim());
            }
        );
        readUsers();

        // eslint-disable-next-line
    }, [apiBaseUrl, withGroup, checkStatus]);

    useEffect(() => {
        const receivedOperation = localStorage.getItem("queryParams");
        if (receivedOperation !== null && receivedOperation !== undefined)
            if (receivedOperation === 'editarGroup') {
                setIsEdetingGroup(true)
                setIsEdetingGlobalUpdate(new Date())
                setWithGroup(false)
                readUsers()
            }
        // eslint-disable-next-line
    }, [isPageloaded])

    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Funçoes Locais                                                                           *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    function nextBtnClick() {
    }

    function backbtnClick() {
        var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'))
        if (groupMenbers.length !== 0) {
            iniciaCookies()
        } else {
            ShowMessageModal(
                {
                    modaltype: 'caution',
                    modalTitle: 'Atenção!',
                    modalMessage: 'Precisa de seleccionar uma opção para poder continuar.',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                    backClick: 'dismiss',
                })
        }
    }

    function backbtnClickOnEdit() {
        var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'))
        if (groupMenbers.length !== 0) {
            iniciaCookies()
        } else {
            ShowMessageModal(
                {
                    modaltype: 'caution',
                    modalTitle: 'Atenção!',
                    modalMessage: 'Precisa de seleccionar uma opção para poder continuar.',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                    backClick: 'dismiss',
                })
        }
    }

    function iniciaCookies() {
        //Inicia as cookies para os utilizaodres
        axios.get(apiBaseUrl + 'Users', { timeout: 50000 }).then((response) => {

            setIsInsertingGlobal(false);

            setTimeout(function () {
                verificaOnlyzone();
            }, 240);

        }, (error) => {
            ShowMessageModal({
                modaltype: 'error',
                modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                nextClick: 'dismiss',
                nextBtnTxt: 'Compreendi',
                crossClick: 'dismiss',
            });
        });
    }

    //----- Fim Funções Top Bar  



    function computSelectedPe(receivedPe) {
        if (receivedPe.eEquipa) {
            axios.get(apiBaseUrl + 'Users', { timeout: 50000 }).then((response) => {
                if (localStorage.getItem('storedGroupMembers') !== null && localStorage.getItem('storedGroupMembers') !== undefined) {
                    AxiosPost(('Zones?uniqueId=' + cookies.get('uniqueDeviceID')), 'message', 'O administrador ainda não deu permissão a nenhum opção neste dispositivo', function comutereponse(response) {
                        setResponse(response.data);
                        //Operação a executar
                        if (response.data.length === 1) {
                            setZone(response.data[0])
                            navigate('/groupProductionPage');
                        } else {

                            //verificase já tem alguma produção a decorrer 
                            navigate('/zonePage');
                        }
                    });
                    return;
                } else {
                    verefyGroup(receivedPe, response.data)
                }
            }, (error) => {
                ShowMessageModal({
                    modaltype: 'error',
                    modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
            });
        } else {
            verefyGroup(receivedPe)
        }
    }


    function verefyGroup(receivedPe) {
        if (isInsertingGroup || isEdetingGroup) {

            var counter = 0;
            var indexFound = 0;

            //Inserir funçionario no grupo
            var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'))
            if (groupMenbers === undefined || groupMenbers === null) {
                groupMenbers = []
            }

            Object.keys(groupMenbers).forEach(function (formInfo, index) {
                if (groupMenbers[index].npe === receivedPe.npe) {
                    counter = counter + 1;
                    indexFound = index;
                }
            });

            if (counter === 0) {
                groupMenbers.push(receivedPe)

                localStorage.setItem('storedGroupMembers', JSON.stringify(groupMenbers));
            } else {
                groupMenbers.splice(indexFound, 1)
                localStorage.setItem('storedGroupMembers', JSON.stringify(groupMenbers));
            }
        } else {
            //Verifica se o pe é grupo ou não
            if (receivedPe.eEquipa) {

                var isOnProduction = seeifisonProduction();
                if (isOnProduction) {

                    if (localStorage.getItem('storedGroupMembers') !== null && localStorage.getItem('storedGroupMembers') !== undefined) {
                        AxiosPost(('Zones?uniqueId=' + cookies.get('uniqueDeviceID')), 'message', 'O administrador ainda não deu permissão a nenhum opção neste dispositivo', function comutereponse(response) {
                            setResponse(response.data);
                            //Operação a executar
                            if (response.data.length === 1) {
                                setZone(response.data[0])
                                navigate('/groupProductionPage')
                            } else {

                                //verificase já tem alguma produção a decorrer 
                                if (localStorage.getItem('grupostamp')) {
                                    navigate('/groupProductionPage')
                                } else {
                                    navigate('/zonePage');
                                }
                            }
                        });
                        return;
                    } else {
                        localStorage.removeItem('storedGroupMembers');
                        setIsInsertingGroup(true);
                        setGroupPe(receivedPe);
                        setWithGroup(!receivedPe.eEquipa);
                    }

                } else {
                    if (localStorage.getItem('storedGroupMembers') !== null && localStorage.getItem('storedGroupMembers') !== undefined) {
                        toast.info('Precisa de actualizar a equipa para hoje', {
                            position: "bottom-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                    localStorage.removeItem('storedGroupMembers');
                    setIsInsertingGroup(true);
                    setGroupPe(receivedPe);
                    setWithGroup(!receivedPe.eEquipa);
                }
            } else {

                if (receivedPe.npe !== undefined && receivedPe.npe !== null) {
                    //Verefica se o user tem alguma produção em execução
                    AxiosPost(('Production/verefyUserInProduction?npe=' + receivedPe.npe), 'function',
                        function emptyresponse(reposnseempty) {
                            verefyZona(0, 0, '', receivedPe);
                        }
                        ,
                        function comutereponse(response) {

                            let counter = 0;
                            let zoneOfProductionId = 0;
                            let obraRef = '';

                            counter = response.data.length;
                            zoneOfProductionId = response.data[0].nctt;
                            obraRef = response.data[0].cuStamp;

                            verefyZona(counter, zoneOfProductionId, obraRef, receivedPe);
                        });
                } else {
                    ShowMessageModal(
                        {
                            modaltype: 'error',
                            modalTitle: 'Erro ao chamar a base de dados',
                            modalMessage: 'Não foi possível comunicar com o servidor, por favor tente de novo. Caso o problema persista entre em contacto com o administrador.',
                            nextClick: 'dismiss',
                            nextBtnTxt: 'Compreendi',
                            crossClick: 'dismiss',
                        })
                }

            }
        }
    }

    function seeifisonProduction() {
        //Verifica se está em produção ou não 
        if (localStorage.getItem('grupostamp') !== null && localStorage.getItem('grupostamp') !== undefined) {
            return true;
        } else {
            return false;
        }
    }

    function verefyZona(counter, zoneOfProductionId, obraRef, receivedPe) {
        AxiosPost(('Zones?uniqueId=' + cookies.get('uniqueDeviceID')), 'message', 'Não foi possivel encontrar uma zona!', function comutereponse(responsectt) {
            if (counter > 0) {
                //Caso já tenha um produção a decorrer
                //Só salta para a pagina de finalizar a produção caso o dispositivo só tenha uma zona, senão vai para a página de zonas
                if (responsectt.data.length === 1) {

                    //Mas antes tenho de verificar se a zona é a correta
                    let zoneOfProduction = {};

                    var found = false;
                    Object.keys(responsectt.data).forEach(function (ctt, index) {
                        if (responsectt.data[index].nctt === zoneOfProductionId) {
                            zoneOfProduction = responsectt.data[index]
                            found = true;
                        }
                    });

                    if (found) {
                        if (obraRef !== undefined && obraRef !== null && obraRef.trim() !== '') {
                            AxiosPost(('Production/getObraByRef?referencia=' + obraRef), 'message', 'Não foi encontrada a obra em produção', function comutereponse(responseoObra) {
                                setCloseProductionRedirectionVars(receivedPe, zoneOfProduction, responseoObra.data[0])

                                navigate('/productionPage?auto=true')
                            });
                        } else {
                            DismissPinModal();
                            ShowMessageModal(
                                {
                                    modaltype: 'error',
                                    modalTitle: 'Erro ao chamar a base de dados',
                                    modalMessage: 'Não foi possível comunicar com o servidor, por favor tente de novo. Caso o problema persista entre em contacto com o administrador.',
                                    nextClick: 'dismiss',
                                    nextBtnTxt: 'Compreendi',
                                    crossClick: 'dismiss',
                                })
                        }
                    } else {
                        //Mostra mensagem
                        toast.warn('Não pode continuar num centro de trabalho diferente ao de início de produção!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                } else {
                    setPe(receivedPe);
                    navigate('/zonePage');
                }
            } else {
                //Caso não tenha operaçãoa decorrer
                setResponse(responsectt.data);

                //Se só tiver uma zona
                if (responsectt.data.length === 1) {
                    setZoneAndPe(receivedPe, responsectt.data[0])
                    navigate('/productionWorkListPage')
                }

                //Se tiver multiplas zonas
                else {
                    setPe(receivedPe);
                    navigate('/zonePage');
                }
            }
        });
    }

    function verificaOnlyzone() {
        axios.post(apiBaseUrl + 'Zones?uniqueId=' + cookies.get('uniqueDeviceID'), { timeout: 50000 }).then((response) => {
            const isDataAvailable = response.data && response.data.length;
            if (isDataAvailable) {
                const myJSON = JSON.stringify(response.data);
                if (myJSON.slice(0, 6) === '"Erro:') {
                    ShowMessageModal(
                        {
                            modaltype: 'error',
                            modalTitle: 'Erro a ler as opções',
                            modalMessage: response.data,
                            nextClick: 'dismiss',
                            nextBtnTxt: 'Compreendi',
                            crossClick: 'dismiss',
                        })
                } else {
                    //Operação a executar

                    const receivedOperation = localStorage.getItem("queryParams");
                    if (receivedOperation === 'editarGroup') {
                        localStorage.setItem("queryParams", "travelobra");
                        navigate('/groupProductionPage')
                    } else {
                        if (queryParams.get('createGroup')) {
                            localStorage.setItem("queryParams", "startProduction");
                            navigate('/groupProductionPage')
                        } else {
                            if (response.data.length === 1) {
                                setZone(response.data[0]);
                                navigate('/groupProductionPage')
                            } else {
                                navigate('/zonePage');
                            }
                        }
                    }
                }
            } else {
                DismisMessageModal();
                toast.info('O administrador ainda não deu permissões a este dispositivo!', {
                    position: "top-right",
                    autoClose: 2700,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }, (error) => {
            ShowMessageModal(
                {
                    modaltype: 'error',
                    modalTitle: 'Erro a ler as opções',
                    modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
        });
    }

    function uniqueidLayout() {
        return (
            <div>
                <div className='skoteCard' >
                    <div className='skotecard-body'>

                        <div className="d-flex">
                            <div className='avatar-sm me-4'>
                                <span className='fa fa-cogs' style={{ padding: '0px', fontSize: '2.8em', paddingTop: '10px', paddingLeft: '5px', color: '#4C82AF' }}></span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                                <h5 className="text-truncate font-size-15"><strong>Bem-vindo(a)</strong></h5>
                                <p className="text-muted">Configuração inicial</p>
                            </div>
                        </div>

                        <h5 className="font-size-15 mt-4"><strong>Passos a seguir :</strong></h5>
                        <p className="text-muted">Por favor aguarde que o administrador conclua a configuração inicial da aplicação. Este processo só será pedido uma vez. </p>
                        <p className="text-muted">No caso de ser solicitado o código de identificação pedimos que apresente o seguinte Id:</p>
                        <h4><strong>{cookies.get('uniqueDeviceID')}</strong></h4>
                        <p className="text-muted">Assim que for concluída a configuração deverá carregar no botão abaixo apresentado para continuar.</p>

                        <div className='myLeftAlign' style={{ marginTop: '30px' }}>
                            <button className='skotebtn' onClick={e => setCheckStatus(!checkStatus)}> {/* Dá refresh á pagina*/}
                                Verificar Estado
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function getUserList(states) {
        if (hasAccess === 1) {
            var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'))
            console.log(groupMenbers)
            return states.map((state, index) =>
                <PeCard key={index} pe={state} autoClick={queryParams.get('createGroup')} selectedMembers={groupMenbers} isEdeting={isEdetingGroup} isInserting={isInsertingGroup} delete={deleteGroup} onClick={currentGroup}></PeCard>
            )
        }
    }

    function readUsers() {
        //Query para ler os funçionarios/grupos que o dispositivo tem acesso
        axios.post(apiBaseUrl + 'Users?uniqueId=' + cookies.get('uniqueDeviceID') + '&withGroup=' + withGroup, { timeout: 50000 }).then((response) => {

            const isDataAvailable = response.data && response.data.length;
            if (isDataAvailable) {
                const myJSON = JSON.stringify(response.data);
                if (myJSON.slice(0, 6) === '"Erro:') {
                    ShowMessageModal(
                        {
                            modaltype: 'errord',
                            modalTitle: 'Erro a ler as opções',
                            modalMessage: response.data,
                            nextClick: 'dismiss',
                            nextBtnTxt: 'Compreendi',
                            crossClick: 'dismiss',
                        })
                } else {
                    var users = [];
                    if (isEdetingGroup) {

                        var groupMembers = JSON.parse(localStorage.getItem('storedGroupMembers'))

                        //Evita ter valores duplicados
                        Object.keys(groupMembers).forEach(function (menber, index) {
                            var found = false;
                            Object.keys(response.data).forEach(function (resMenber, indexRes) {
                                if (response.data[indexRes].npe === groupMembers[menber].npe) {
                                    found = true;
                                }
                            });

                            if (!found) {
                                users.push(groupMembers[index])
                            }
                        });

                    } else {
                        setisPageloaded(new Date())
                    }

                    users = users.concat(response.data)

                    //Operação a executar
                    setReponseSize(users.length);
                    setResponse(users);
                    setHasAccess(1);
                }
            } else {

                if (withGroup) {
                    setHasAccess(2);
                    DismisMessageModal();
                    toast.warn('O administrador ainda não deu permissões a este dispositivo!', {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    var users = [];
                    if (isEdetingGroup) {

                        console.log('entrou cá')
                        var groupMembers = JSON.parse(localStorage.getItem('storedGroupMembers'))

                        //Evita ter valores duplicados
                        Object.keys(groupMembers).forEach(function (menber, index) {
                            var found = false;
                            Object.keys(response.data).forEach(function (resMenber, indexRes) {
                                if (response.data[indexRes].npe === groupMembers[menber].npe) {
                                    found = true;
                                }
                            });

                            if (!found) {
                                users.push(groupMembers[index])
                            }
                        });

                        users = users.concat(response.data)

                    //Operação a executar
                    setReponseSize(users.length);
                    setResponse(users);
                    setHasAccess(1);

                    } else {
                        resetVarsGroup()
                        DismisMessageModal();
                        toast.warn('Não existem funçionarios disponiveis no momento!', {
                            position: "top-right",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }
            }
        }, (error) => {
            ShowMessageModal(
                {
                    modaltype: 'error',
                    modalTitle: 'Erro a ler as opções',
                    modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
        });
    }

    //----- Funções footer
    function nextFooterClick() {
        resetVarsGroup()
    }

    function nextFooterClickOnEdit() {
        setIsEdetingGroup(false)
        localStorage.setItem("queryParams", "noOP");
        navigate('/groupProductionPage')
    }

    function resetVarsGroup() {
        //variavel para vereificar se ele está a editar ou não
        if (localStorage.getItem('jorneystamp') === null || localStorage.getItem('jorneystamp') === undefined) {
            ShowLoadingModal();


            
            localStorage.removeItem('storedGroupMembers');
            localStorage.removeItem('grupostamp');
            ResetPe();
            localStorage.removeItem('storedGroupMembers');

            setIsInsertingGroup(false);
            setWithGroup(true);

            setTimeout(function () {
                DismisLoadingModal();
                navigate('/userPage')
            }, 150);
        } else {

            ShowMessageModal(
                {
                    modaltype: 'warning',
                    modalTitle: 'Limpar equipa',
                    modalMessage: 'Não é possível modificar a equipa enquanto tem uma deslocação a decorrer!',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
        }
    }

    //Esta função foi criada para quando apagarmos registos da base de dados, não aparacer a mesagem que ainda tem umaprodução a decorrer  
    function clearAllCookies() {
        cookies.remove('projectConfigStatus')
        localStorage.removeItem('lastSetInList')
        localStorage.removeItem('grupostamp')
        localStorage.removeItem('jorneystamp')
        localStorage.removeItem('jorneyStatus')
        localStorage.removeItem('storedGroupMembers')

        navigate('/userPage'); //Para dar refresh
    }

    //--- Fim funções

    //Para não dar erro no modal
    Modal.setAppElement('body');

    function loadTopBar() {

        if (isInsertingGroup) {
            return <div className='topbar'><TopBar texto='Selecione os membros:' type='blue' backText='Continuar' nextBtnClick={e => console.log()} backbtnClick={backbtnClickOnEdit} layout='2'></TopBar></div>
        }

        //Falta configurar isto
        if (isEdetingGroup) {
            return <div className='topbar'><TopBar texto='Selecione os membros:' type='blue' backText='Continuar' nextBtnClick={nextBtnClick} backbtnClick={backbtnClick} layout='2'></TopBar></div>
        }
    }

    function loadFooter() {
        //Falta mudar isto
        if (isEdetingGroup) {
            return <div className="footer"><BottomBar nextText={'Cancelar'} type={'userPage'} nextBtnClick={e => nextFooterClickOnEdit()} backText={'Cancelar'} backbtnClick={e => console.log()}></BottomBar></div>
        } else {
            if (isInsertingGroup) {
                return <div className="footer"><BottomBar nextText={'Cancelar'} type={'userPage'} nextBtnClick={e => nextFooterClick()} backText={'Cancelar'} backbtnClick={e => console.log()}></BottomBar></div>
            } else {
                return (
                    <div className='footerName' style={{ background: '#313036' }}>
                        <div className="row">
                            <div className="col-sm-6">
                                <h5 style={{ paddingTop: '10px', paddingLeft: '12px', margin: '0px' }}>
                                    <strong>
                                        <span style={{ color: '#6BD9E6' }}>{localStorage.getItem('dispName')}</span>
                                    </strong>
                                </h5>
                                <h5 style={{ margin: '0px', paddingTop: '4px', paddingLeft: '12px', color: '#D7D9DE', fontSize: '12px' }}>ID: {cookies.get('uniqueDeviceID')}</h5>
                            </div>
                            <div className="col-sm-6">
                                <div className="row" style={{ marginTop: '7px', padding: '0px 10px' }}>
                                    <div className="col-sm-6" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <h4 style={{ fontSize: '16px' }}>
                                            <svg width="14" height="14">
                                                <rect width="14" height="14" style={{ fill: "#E97567", strokeWidth: "1", stroke: "#994C43" }} />
                                            </svg>
                                            <strong>&nbsp;Com Produção</strong>
                                        </h4>
                                    </div>
                                    <div className="col-sm-6" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <h4 style={{ fontSize: '16px' }}>
                                            <svg width="14" height="14">
                                                <rect width="14" height="14" style={{ marginTop: '5px', fill: "#4A82B0", strokeWidth: "1", stroke: "#2E516E" }} />
                                            </svg>
                                            <strong>&nbsp;Sem Produção</strong>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    function addcookie() { localStorage.setItem('myCat', 'Tom') }
    function showcookie() { alert(localStorage.getItem('myCat')) }
    function removecookie() { localStorage.removeItem('myCat'); }

    function showCookies() {
        return (
            <div>
                <button onClick={e => addcookie()}>
                    add cookie
                </button>
                <button onClick={e => showcookie()}>
                    show cookie
                </button>
                <button onClick={e => removecookie()}>
                    remove cookie
                </button>
                <p>Project Config Status: {cookies.get('projectConfigStatus')}</p>
                <p>Last Set In List: {localStorage.getItem('lastSetInList')}</p>
                <p>Grupostamp: {localStorage.getItem('grupostamp')}</p>
                <p>Jorneystamp: {localStorage.getItem('jorneystamp')}</p>
                <p>JorneyStatus: {localStorage.getItem('jorneyStatus')}</p>
            </div>
        )
    }

    return (
        <div className="UserPage" style={(hasAccess === 1 || hasAccess === 0) ? { backgroundColor: '#ECECEC' } : { backgroundColor: '#4C82AF' }}>
            {loadTopBar()}
            <div className={"pageContent"} >
                {hasAccess === 1 ?
                    <div className='flexLayoutScrollable' style={(isInsertingGroup || isEdetingGroup) ? { marginTop: '54px' } : { marginTop: '0px', marginBottom: '30px' }}
                    >
                        {getUserList(response)}
                        {/*showCookies()*/}
                    </div>
                    :
                    (hasAccess === 2 ? <div>{uniqueidLayout()}</div> : false)
                }



                {loadFooter()}

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

            <PinModal
                pinAccepted={function pinAccepted() {
                    computSelectedPe(currentPe);
                }}
                user={currentPe}
            >
            </PinModal>
        </div>
    )
}
export default UserPage